"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, } from "react";
import { cn } from "../utils/cn.js";
import { Icon } from "./Icon.js";
const ROW_HEIGHT = {
    compact: "[--wm-row-h:32px]",
    default: "[--wm-row-h:44px]",
    cosy: "[--wm-row-h:56px]",
};
const TableContext = createContext({ density: "default" });
export function Table({ density = "default", className, children, ...rest }) {
    return (_jsx(TableContext.Provider, { value: { density }, children: _jsx("table", { "data-slot": "table", "data-density": density, className: cn("w-full border-collapse text-body text-ink-700", ROW_HEIGHT[density], className), ...rest, children: children }) }));
}
export function THead({ className, children, ...rest }) {
    return (_jsx("thead", { "data-slot": "thead", className: cn("border-b border-ink-200", className), ...rest, children: children }));
}
export function TBody({ className, children, ...rest }) {
    return (_jsx("tbody", { "data-slot": "tbody", className: className, ...rest, children: children }));
}
export function TR({ className, children, ...rest }) {
    return (_jsx("tr", { "data-slot": "tr", className: cn("h-[var(--wm-row-h)] border-b border-ink-100 last:border-b-0", "transition-colors duration-fast ease-out hover:bg-paper-warm", className), ...rest, children: children }));
}
export function TH({ sort, onSort, className, children, ...rest }) {
    const sortable = !!onSort;
    return (_jsx("th", { "data-slot": "th", scope: "col", "aria-sort": sort === "asc" ? "ascending" : sort === "desc" ? "descending" : "none", className: cn("px-3 text-start text-overline font-semibold uppercase tracking-[0.014em] text-ink-500", sortable && "cursor-pointer select-none hover:text-ink-700", className), onClick: sortable ? onSort : undefined, ...rest, children: _jsxs("span", { className: "inline-flex items-center gap-1", children: [children, sortable ? (_jsx(Icon, { name: sort === "desc" ? "arrowDown" : sort === "asc" ? "arrowUp" : "chevronDown", size: 14, "aria-hidden": true, className: cn(sort ? "text-ink-700" : "text-ink-400") })) : null] }) }));
}
export function TD({ className, children, ...rest }) {
    const { density } = useContext(TableContext);
    return (_jsx("td", { "data-slot": "td", className: cn("px-3 align-middle", density === "compact" && "py-1", density === "default" && "py-2", density === "cosy" && "py-3", className), ...rest, children: children }));
}
